import type {BasicCategoryOfStructure} from './BasicCategoryOfStructure';

export type BasicStructure = {
  version: number;
  categories: Array<BasicCategoryOfStructure>;
};
